module.exports = __webpack_public_path__ + "static/codento-9cf15a611ff7015e0c4d57abb5202db8.svg";